module.exports = __webpack_public_path__ + "assets/img/b3668b8a676920daf90d4e3ea1694b27.svg";